<template>
    <div class="page-setting has-bc biz-home-default">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}{{isAllGroup || isBizVerified != 'NORMAL'?'':' - '+userGroupName}}</h1>
        </div>
        <home-default-comp></home-default-comp>
    </div>
</template>
<script>
import homeDefaultComp from '@/components/bussiness/personalHome/home/homeDefaultComp.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {

        }
    },
    computed: {
        ...mapGetters({
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            userGroupName: 'GET_BIZ_GROUP_NAME',
            isBizVerified: 'GET_BIZ_COMPANY_IS_VERIFIED',

        })
    },
    components: {
        homeDefaultComp
    }
}
</script>
<style lang="scss">
    .biz-home-default{
        
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/personalHome/home/homeDefault.vue